import type { ReactNode } from "react";

interface MedicalRecordMobileLayoutProps {
  header: ReactNode;
  recordingBar?: ReactNode;
  patient: ReactNode;
  tabs: ReactNode;
  actions: ReactNode;
  overlays?: ReactNode;
  shouldShowTranscriptionBar: boolean;
  children: ReactNode;
}

export function MedicalRecordMobileLayout({
  header,
  recordingBar,
  patient,
  tabs,
  actions,
  overlays,
  children,
  shouldShowTranscriptionBar: _shouldShowTranscriptionBar
}: MedicalRecordMobileLayoutProps) {
  return (
    <div data-testid="medical-record-mobile-layout" className="flex min-h-[calc(100dvh-64px)] flex-col bg-background-app text-foreground md:hidden">
      <div className="flex flex-col bg-background-app text-foreground">
        {header}
        {recordingBar}
      </div>
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="shrink-0 px-4 pt-3">{patient}</div>
        <div className="shrink-0 px-4 pb-2 pt-3">{tabs}</div>
        <main className="min-h-0 flex-1 overflow-y-auto px-4 pb-4 pt-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {children}
        </main>
        {actions}
        {overlays}
      </div>
    </div>
  );
}
